<div class="popover-overlay">
    <div class="popover-container">
      <!-- Header -->
      <div class="popover-header">
        <h2>{{ title }}&nbsp;-&nbsp;{{entityName}}</h2>
        <button class="close-button" (click)="onCancel()" aria-label="Close">
          <span aria-hidden="true">✕</span>
        </button>
      </div>
  
      <!-- Content -->
      <div class="popover-content" [style.max-height]="maxHeight">
        <div class="selection-section">
            <div class="sub-header">
                Inventory
            </div>
          <!-- Search -->
          <div class="search-container" *ngIf="showSearchBar">
            <input
              type="text"
              class="search-input"
              [placeholder]="searchPlaceholder"
              [formControl]="searchControl"
              aria-label="Search"
            />
          </div>
          
          <!-- Items -->
          <div class="selectable-items">
            <ng-container *ngFor="let item of filteredItems; trackBy: trackById">
              <!-- Custom template if provided -->
              <ng-container *ngIf="customItemTemplate; else defaultItemTemplate">
                <div 
                  class="selectable-item" 
                  [class.selected]="isSelected(item)"
                  [class.disabled]="isDisabled(item)"
                  (click)="!isDisabled(item) && toggleSelection(item)"
                >
                  <ng-container 
                    [ngTemplateOutlet]="customItemTemplate" 
                    [ngTemplateOutletContext]="{ 
                      $implicit: item, 
                      selected: isSelected(item),
                      disabled: isDisabled(item) 
                    }"
                  ></ng-container>
                </div>
              </ng-container>
              
              <!-- Default template -->
              <ng-template #defaultItemTemplate>
                <div 
                  class="selectable-item" 
                  [class.selected]="isSelected(item)"
                  [class.disabled]="isDisabled(item)"
                  (click)="!isDisabled(item) && toggleSelection(item)"
                >
                {{ item.deviceName }}
                  <span *ngIf="isSelected(item)" class="remove-icon" aria-hidden="true">✕</span>
                </div>
              </ng-template>
            </ng-container>
          </div>
        </div>
      </div>
      
      <!-- Footer -->
      <div class="popover-footer">
        <button class="btn-cancel" (click)="onCancel()">Cancel</button>
        <button class="btn-done" [disabled]="!hasSelection" (click)="onDone()">Done</button>
      </div>
    </div>
  </div>